<template>
  <div class="d-flex">
    <v-tooltip left>
      <v-btn
        slot="activator"
        flat
        icon
        class="ml-0 pl-0 mr-0 pr-0"
        @click="updateCriteria"
      >
        <v-icon>import_export</v-icon>
      </v-btn>
      {{ $t('message.searcher.sort.criteria.' + criteria) }}
    </v-tooltip>
    <v-menu>
      <v-btn
        slot="activator"
        flat
        class="mx-0 pl-1 pr-0 py-0 text-none"
      >
        {{ $t(`message.searcher.sort.options.${label}`) }}
        <v-icon class="ma-0">
          arrow_drop_down
        </v-icon>
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="option in options"
          :key="option"
          ripple
          @click="updateOption(option)"
        >
          <v-list-tile-avatar>
            <v-icon v-show="option === label">
              check
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $t('message.searcher.sort.options.' + option) }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'NxSearcherSort',
  props: {
    // Current order
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    label() {
      return Object.keys(this.value)
        .shift();
    },
    criteria() {
      return Object.values(this.value)
        .shift();
    },
    icon() {
      if (this.criteria === 'ASC') return 'arrow_drop_up';
      return 'arrow_drop_down';
    },
  },
  methods: {
    updateCriteria() {
      this.$emit('input', { [this.label]: this.criteria === 'ASC' ? 'DESC' : 'ASC' });
    },
    updateOption(option) {
      this.$emit('input', { [option]: this.criteria });
    },
  },
};
</script>
